// import "./Terminal/Terminal.css"

// TODO: fix this
export const Four0Four = () => {
    return (
        <div>404</div>
    )
}